module.exports = __webpack_public_path__ + "static/img/knowledgenew6.1ef3b216.jpeg";